/** Mantém até 14 dígitos. */
export function stripCnpjToDigits(value: string): string {
  return value.replace(/\D/g, "").slice(0, 14);
}

/**
 * Máscara progressiva: `99.999.999/9999-99` (14 dígitos).
 */
export function formatCnpjMask(value: string): string {
  const d = stripCnpjToDigits(value);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

/** Para envio à API: só dígitos ou `null` se vazio. */
export function cnpjToApiPayload(maskedOrDigits: string): string | null {
  const d = stripCnpjToDigits(maskedOrDigits);
  return d.length === 0 ? null : d;
}
